var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#147F26"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.084 18.492H24.6757C22.7007 18.492 21.0923 16.8837 21.0923 14.9087V12.5003C21.0923 12.042 20.7173 11.667 20.259 11.667H16.7257C14.159 11.667 12.084 13.3337 12.084 16.3087V23.692C12.084 26.667 14.159 28.3337 16.7257 28.3337H23.2757C25.8423 28.3337 27.9173 26.667 27.9173 23.692V19.3253C27.9173 18.867 27.5423 18.492 27.084 18.492Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.1658 11.8421C22.8241 11.5004 22.2324 11.7337 22.2324 12.2087V15.1171C22.2324 16.3337 23.2658 17.3421 24.5241 17.3421C25.3158 17.3504 26.4158 17.3504 27.3574 17.3504C27.8324 17.3504 28.0824 16.7921 27.7491 16.4587C26.5491 15.2504 24.3991 13.0754 23.1658 11.8421Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFile);
export default __webpack_public_path__ + "static/media/file.bbd27fcacdb9b58a1b6fd7a37707082e.svg";
export { ForwardRef as ReactComponent };